var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.4C1.2268 9.4 0.6 8.7732 0.6 8V2C0.6 1.2268 1.2268 0.6 2 0.6H6C6.7732 0.6 7.4 1.2268 7.4 2V8C7.4 8.7732 6.7732 9.4 6 9.4H2ZM2 17.4C1.2268 17.4 0.6 16.7732 0.6 16V14C0.6 13.2268 1.2268 12.6 2 12.6H6C6.7732 12.6 7.4 13.2268 7.4 14V16C7.4 16.7732 6.7732 17.4 6 17.4H2ZM12 17.4C11.2268 17.4 10.6 16.7732 10.6 16V10C10.6 9.2268 11.2268 8.6 12 8.6H16C16.7732 8.6 17.4 9.2268 17.4 10V16C17.4 16.7732 16.7732 17.4 16 17.4H12ZM10.6 2C10.6 1.2268 11.2268 0.6 12 0.6H16C16.7732 0.6 17.4 1.2268 17.4 2V4C17.4 4.7732 16.7732 5.4 16 5.4H12C11.2268 5.4 10.6 4.7732 10.6 4V2Z",
    stroke: "#079F9F",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon2);
export default __webpack_public_path__ + "static/media/dashboardIcon2.a12114686c3fdcc2a6caddf28bf1a1e2.svg";
export { ForwardRef as ReactComponent };